<template>
  <div>
    <v-dialog v-model="dialog_open" max-width="700" persistent>
      <v-card>
        <v-card-title class="py-0">
          <v-col cols="10" sm="11">
            <span class="ml-3 font-weight-bold "
              style="font-size: 24px; color: #000000; font-family: 'Sarabun', sans-serif;">
              ใบสั่งยา
            </span>
          </v-col>
          <v-col cols="2" sm="1">
            <v-btn icon @click="closeDialog()" style="text-align:right;">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-card-title>
        <v-card-text class="py-0" v-if="this.mode === 'approve'">
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="6">
                  <span style="font-size: 16px;">
                    เลขที่
                  </span>
                  <v-text-field v-model="payload.number" hide-details outlined dense placeholder="กรุณากรอกเลขที่"
                    class="mt-1" disabled style="background-color: #E8E9E9;" @keypress="validateNumber"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-title class="py-0">
          <v-col cols="12" class="pb-0">
            <span style="font-size: 18px; color: #1A1C1D; font-family: 'Sarabun', sans-serif;">
              ข้อมูลแพทย์
            </span>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-card-title>
        <v-card-text class="py-0">
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="6">
                  <span style="font-size: 16px;">
                    แพทย์ <span style="color: red;">*</span>
                  </span>
                  <v-combobox attach v-model="select_doc" placeholder="ชื่อแพทย์" :item="searchDoc" outlined dense
                    hide-details :items="searchDoc" @input="searchDoctor" item-text="name_th" return-object class="mt-1"
                    :rules="[v => !!v || 'กรุณากรอกข้อมูล']" :disabled="isApprove"
                    :style="isApprove ? 'background-color: #E8E9E9;' : ''" color="#00A99D">
                    <template v-slot:append>
                      <img src="../../assets/icon/medcert/search.svg" alt="search">
                    </template>
                  </v-combobox>
                </v-col>

                <v-col cols="6">
                  <span style="font-size: 16px;">
                    ใบอนุญาต/หนังสือรับรอง เลขที่
                  </span>
                  <v-text-field v-model="payload.doctor.doctor_license" placeholder="ใบอนุญาตเลขที่" hide-details
                    outlined dense class="mt-1" disabled style="background-color: #E8E9E9;"></v-text-field>
                </v-col>

                <v-col cols="12">
                  <span style="font-size: 16px;">
                    ที่อยู่
                  </span>
                  <v-textarea v-model="payload.biz.biz_address" auto-grow hide-details outlined dense disabled
                    class="mt-1" style="background-color: #E8E9E9;"></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-card-text>

        <v-card-title class="py-0">
          <v-col cols="12" class="pb-0">
            <span style="font-size: 18px; color: #1A1C1D; font-family: 'Sarabun', sans-serif;">
              ข้อมูลผู้ป่วย
            </span>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-card-title>
        <v-card-text class="py-0">
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="6">
                  <span style="font-size: 16px;">
                    ชื่อ-นามสกุลผู้ป่วย
                  </span>
                  <v-text-field v-model="payload.patient.patient_name" hide-details outlined dense disabled class="mt-1"
                    style="background-color: #E8E9E9;"></v-text-field>
                </v-col>

                <v-col cols="6">
                  <span style="font-size: 16px;">
                    HN
                  </span>
                  <v-text-field v-model="payload.patient.hn" hide-details outlined dense class="mt-1"></v-text-field>
                </v-col>

                <v-col cols="6">
                  <span style="font-size: 16px;">
                    เลขประจำตัวประชาชน
                  </span>
                  <v-text-field v-model="show_patient_cid" hide-details outlined dense disabled class="mt-1"
                    style="background-color: #E8E9E9;"></v-text-field>
                </v-col>

                <v-col cols="6">
                  <span style="font-size: 16px;">
                    วันเกิด
                  </span>
                  <v-text-field v-model="show_patient_birth" hide-details outlined dense disabled class="mt-1"
                    style="background-color: #E8E9E9;"></v-text-field>
                </v-col>

                <v-col cols="6">
                  <span style="font-size: 16px;">
                    อายุ
                  </span>
                  <v-text-field v-model="payload.patient.patient_age" hide-details outlined dense disabled class="mt-1"
                    style="background-color: #E8E9E9;"></v-text-field>
                </v-col>

                <v-col cols="6">
                  <span style="font-size: 16px;">
                    เบอร์โทรศัพท์
                  </span>
                  <v-text-field v-model="payload.patient.mobile" hide-details outlined dense
                    placeholder="กรุณากรอกเบอร์โทรศัพท์" class="mt-1" @keypress="validateNumber"></v-text-field>
                </v-col>

                <v-col cols="12">
                  <span style="font-size: 16px;">
                    ที่อยู่
                  </span>
                  <v-textarea v-model="display_address" auto-grow hide-details outlined dense class="mt-1"></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-card-text>

        <v-card-title class="py-0">
          <v-col cols="12" class="pb-0">
            <span style="font-size: 18px; color: #1A1C1D; font-family: 'Sarabun', sans-serif;">
              การวินิจฉัย
            </span>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-card-title>
        <v-card-text class="py-0">
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <span style="font-size: 16px;">
                    ยาที่แพ้:
                  </span>
                  <v-text-field v-model="payload.allergic_drugs" hide-details outlined dense
                    class="mt-1"></v-text-field>
                </v-col>

                <v-col cols="12">
                  <span style="font-size: 16px;">
                    การวินิจฉัยหลัก:
                  </span>
                  <v-text-field v-model="payload.primary_diagnosis" hide-details outlined dense
                    class="mt-1"></v-text-field>
                </v-col>

                <v-col cols="12">
                  <span style="font-size: 16px;">
                    การวินิจฉัยรอง:
                  </span>
                  <v-text-field v-model="payload.secondary_diagnosis" hide-details outlined dense
                    class="mt-1"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-card-text>

        <v-card-title class="py-0">
          <v-col cols="12" class="pb-0">
            <span style="font-size: 18px; color: #1A1C1D; font-family: 'Sarabun', sans-serif;">
              การสั่งยา
            </span>
            <v-btn color="primary" small @click="addItem">
              เพิ่มรายการ
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-card-title>
        <v-card-text class="py-0">
          <v-form>
            <v-container>
              <v-row v-for="(item, index) in drugItems" :key="index">
                <v-col cols="6" class="d-flex justify-end pr-0">
                  <!-- เลือกยา -->
                  <v-autocomplete v-model="item.selectDrug" :items="drugOption" item-text="name_drug" return-object
                    hide-details outlined dense placeholder="กรุณาเลือกยา"
                    @change="onDrugChange(item.selectDrug, index)">
                    <template slot="no-data">
                      <span class="pl-2">ไม่มีข้อมูล</span>
                    </template>
                  </v-autocomplete>
                  <span style="color: red;" class="font-16 pl-1">*</span>
                </v-col>
                <v-col cols="2" class="d-flex justify-end pr-0">
                  <!-- กรอกจำนวนยา -->
                  <v-text-field v-model="item.quantity" hide-details outlined dense placeholder="จำนวน"
                    @keypress="validateNumber"></v-text-field>
                  <span style="color: red;" class="font-16 pl-1">*</span>
                </v-col>
                <v-col cols="1" class="center px-0">
                  <!-- แสดงหน่วย -->
                  <div>{{ item.unit ? `(${item.unit})` : "หน่วย" }}</div>
                </v-col>
                <v-col cols="2" class="pr-0">
                  <!-- กรอกหมายเหตุ -->
                  <v-text-field v-model="item.note" hide-details outlined dense placeholder="หมายเหตุ"></v-text-field>
                </v-col>
                <v-col cols="1" class="px-0">
                  <v-btn icon @click="removeItem(index)" :disabled="drugItems.length == 1">
                    <v-icon color="red">mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-card-text>

        <v-card-text class="py-0">
          <v-row align="center" class="px-8 mt-5">
            <v-col cols="6" align="end">
              <v-btn @click="closeDialog()" style="width: 100%;" outlined color="#00a99d" dark
                class="card-medium-cancel">
                <span style="color: #00a99d;" class="font-14">ยกเลิก</span>
              </v-btn>
            </v-col>
            <v-col cols="6" align="start">
              <v-btn class="card-medium" style="width: 100%;" depressed color="#00a99d" :disabled="disabled_btn"
                :loading="loading_btn" @click="btn_name == 'อนุมัติเอกสาร' ? approveDoc() : requestDoc()">
                <span style="color: #FFFFFF;" class="font-14">{{ btn_name }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <ApproveDoc ref="approveDoc" />
  </div>
</template>

<script>
import moment from 'moment'

import ApproveDoc from '@/components/dialog/ApproveDialog.vue'
import { EventBus } from "@/EventBus"
import functioncryto from "@/services/encrypt.js";

export default {
  components: {
    ApproveDoc
  },
  data: () => ({
    loading_btn: false,
    dialog_open: false,

    payload: {
      //biz
      biz: {
        biz_address: "",
        biz_id: "",
        biz_name: "",
      },
      //doctor
      doctor: {
        biz_id: "",
        doctor_license: "",
        doctor_name: "",
        one_id: ""
      },
      //patient
      patient: {
        biz_id: "",
        one_id: "",
        patient_address: {},
        patient_id_card_number: "",
        patient_name: "",
        patient_age: "",
      },
    },
    show_patient_cid: "",
    show_patient_birth: "",

    select_doc: {
      name_th: "เลือกแพทย์"
    },

    display_address: "",

    //ข้อมูลการตรวจ
    health_check_date: "",
    request_date: "",

    doc_code: "",
    doc_name: "",

    _id: "",

    menu2: "",
    today: moment().format("YYYY-MM-DD"),
    btn_name: "",
    date_format: "วัน/เดือน/ปี",
    searchDoc: [],
    isApprove: false,
    cid: "",

    rules: {
      required: v => !!v || 'กรุณากรอกข้อมูล',
    },

    mode: "",
    patient_id: "",
    status_display_address: false,
    drugItems: [
      {
        selectDrug: null,
        name: "",
        quantity: "",
        unit: "",
        usage: "",
        note: "",
      },
    ],
    drugOption: []
  }),
  watch: {
  },
  async mounted() {

  },
  computed: {
    disabled_btn() {
      // เช็คทุกรายการยา ว่าต้องมี selectDrug และ quantity
      const isDrugInvalid = this.drugItems.some(item => {
        return !item.selectDrug || !item.quantity;
      });

      if (
        !this.select_doc ||
        this.select_doc.name_th === 'เลือกแพทย์' ||
        isDrugInvalid
      ) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    async open(input, age = null) {
      // console.log(input)
      this.select_doc = {
        name_th: "เลือกแพทย์"
      }
      this.patient_id = input.patient_id
      this.payload = input.item
      this.health_check_date = input.item.health_check_date
      this.request_date = input.item.request_date
      this.mode = input.mode
      this.btn_name = "ออกเอกสาร"

      this.payload.patient.patient_age = age ? age : this.calculateAge(input.item.patient.patient_birth)

      let address = ""

      if (Array.isArray(this.payload.patient.patient_address)) {
        if (this.payload.patient.patient_address.length > 0) {
          const index_address = this.payload.patient.patient_address.length - 1
          for (const key of Object.entries(this.payload.patient.patient_address[index_address])) {
            if (key[1] && key[1] != 'null') {
              if (key[0] == "houseNo") {
                address = address + "บ้านเลขที่ " + key[1] + " "
              } else if (key[0] == "moo") {
                address = address + "หมู่ที่ " + key[1] + " "
              } else if (key[0] == "soi") {
                address = address + "ซอย " + key[1] + " "
              } else if (key[0] == "amphur") {
                address = address + "อำเภอ/เขต " + key[1] + " "
              } else if (key[0] == "tambon") {
                address = address + "ตำบล/แขวง " + key[1] + " "
              } else if (key[0] == "province") {
                address = address + "จังหวัด " + key[1] + " "
              } else if (key[0] == "zipcode") {
                address = address + "รหัสไปรษณีย์ " + key[1] + " "
              }
            }
          }
          this.display_address = address
        }
      } else {
        this.display_address = this.payload.patient.patient_address
      }
      if (this.display_address) {
        this.status_display_address = true
      }

      this.show_patient_cid = functioncryto.decrypt(this.payload.patient.patient_id_card_number)
      if (input.mode == 'input') {
        this.show_patient_birth = this.payload.patient.patient_birth ? moment(this.payload.patient.patient_birth).add(543, "year").locale("th").format("DD/MM/YYYY") : ""
        this.drugItems = [
          {
            selectDrug: null,
            name: "",
            quantity: "",
            unit: "",
            usage: "",
            note: "",
          },
        ]
      } else {
        this.show_patient_birth = this.payload.patient.patient_birth
      }

      this.doc_code = input.doc_code
      this.doc_name = input.doc_name

      if (input.mode == "approve") {
        this._id = input._id
        this.isApprove = true
        this.btn_name = "อนุมัติเอกสาร"
      }
      await this.getStaff()
      await this.getDrugList()
      if (input.mode == "approve") {
        this.drugItems = input.item.drug_list
      }
      this.dialog_open = true
      setTimeout(() => {
        document.getElementsByClassName('v-dialog--active')[0].scrollTop = 0
      }, 100)
    },
    closeDialog() {
      this.dialog_open = false
    },
    formatDate(date) {
      return moment(date).add(543, "year").locale("th").format("DD MMMM YYYY")
    },
    async approveDoc() {
      // console.log("approve", this.payload)
      // console.log("id", this._id)
      try {
        this.payload.patient.patient_address = this.display_address
        this.payload.patient.patient_birth = this.show_patient_birth
        this.payload.drug_list = this.drugItems
        let params = new URLSearchParams()
        params.append("id", this._id)
        params.append("doc_type", this.doc_code)
        await this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/updateTransaction?${params}`,
          {
            payload: this.payload
          }
        ).then((res) => {
          // console.log("=>", res)
          if (res.data.result === "success") {
            this.creatPdf()
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    async creatPdf() {
      // console.log(this.select_doc)
      this.loading_btn = true
      this.payload.patient.patient_address = this.display_address
      this.payload.patient.patient_id_card_number = functioncryto.decrypt(this.payload.patient.patient_id_card_number)
      this.payload.patient.patient_birth = this.show_patient_birth
      await this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/sign/create-med-cert`,
        {
          payload: this.payload,
          sign_position: 2.2,
          doc_code: this.doc_code,
          doc_name: this.doc_name,
          pageToSign: 1,
          biz_id: sessionStorage.biz_id,
          request_date: this.request_date,
          health_check_date: this.health_check_date,
          file_id: "",
          status: "request"
        }
      ).then((res) => {
        // console.log(res)
        if (res.data.result == "success") {
          let item = {
            id: this._id,
            doc_code: this.doc_code,
            pdf_data: res.data.data,
            doctor_name: this.payload.doctor.doctor_name,
            cid: functioncryto.encrypt(this.payload.patient.patient_id_card_number),
            payload_success: res.data.payload
          }

          if (this.doc_code == "PRESCRIPTION_CERT") {
            this.$refs.approveDoc.open(item)
          }
        }

        this.loading_btn = false
        this.closeDialog()
      })
        .catch((err) => {
          this.loading_btn = false
          console.log('err:', err.message)
        })
    },
    async requestDoc() {
      this.$swal.fire({
        title: `<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>หากคุณต้องการขอ ${this.doc_name} ของ "${this.payload.patient.patient_name}"<br/>กรุณากดยืนยันเพื่อดำเนินการต่อ</span>`,
        showCancelButton: true,
        cancelButtonText: "<span style='font-size: 14px;font-family: Sarabun, sans-serif;'>ยกเลิก</span>",
        confirmButtonText: "<span style='font-size: 14px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
        confirmButtonColor: "#00A99D",
        cancelButtonColor: "#F5222D",
        reverseButtons: true,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.confirmDoc()
        }
      })
    },
    async confirmDoc() {
      // this.payload.patient.patient_address = this.display_address
      // this.payload.patient.patient_birth = this.show_patient_birth
      // this.payload.time = moment(new Date()).locale("th").format("HH:mm น.")
      // this.payload.drug_list = this.drugItems
      // console.log("this.payload", this.payload)
      // EventBus.$emit('getData')
      try {
        // console.log("doc", this.select_doc)
        this.payload.patient.patient_address = this.display_address
        this.payload.patient.patient_birth = this.show_patient_birth
        this.payload.time = moment(new Date()).locale("th").format("HH:mm น.")
        this.payload.drug_list = this.drugItems
        console.log("this.payload", this.payload)
        let params = new URLSearchParams()
        params.append("doc_type", this.doc_code)
        await this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/addTransaction?${params}`,
          {
            payload: this.payload,
            doc_code: this.doc_code,
            doc_name: this.doc_name,
            create_by: sessionStorage.getItem("role_name"),
            patient_id: this.patient_id
          }).then((res) => {
            // console.log(res)
            this.dialog_open = false
            if (res.data.result === 'success') {
              this.$swal.fire({
                icon: "success",
                title: `<span style="font-size: 20px;">ขอเอกสารสำเร็จ</span>`,
                showConfirmButton: false,
                timer: 2000,
              })
              EventBus.$emit('getData')
            }
          })
      } catch (err) {
        console.log(err)
      }
    },
    async getStaff() {
      try {
        let params = new URLSearchParams()
        params.append("biz_id", sessionStorage.biz_id)
        params.append("mode", "all-doctor")
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/getStaff?${params}`).then((res) => {
          // console.log(">>> res", res, " ---------------")

          if (this.mode == "input") {
            if (sessionStorage.role_name == "แพทย์") {
              for (let i in res.data.data) {
                if (res.data.data[i].one_id == sessionStorage.oneId) {
                  this.select_doc = res.data.data[i];
                }
              }
            }
          } else if (this.mode == "approve") {
            this.select_doc = {
              biz_id: this.payload.doctor.biz_id,
              doctor_license: this.payload.doctor.doctor_license,
              name_th: this.payload.doctor.doctor_name,
              one_id: this.payload.doctor.one_id
            }
          }

          this.searchDoc = res.data.data
        })
      } catch (err) {
        console.log(err)
      }
    },
    async getDrugList() {
      try {
        let params = new URLSearchParams()
        params.append("biz_id", sessionStorage.biz_id)
        params.append("limit", 9999);
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/druglists?${params}`).then((res) => {
          // console.log(">>> resdruglists", res, " ---------------")
          if (res.data.data && res.data.data[0].data) {
            this.drugOption = res.data.data[0].data
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    searchDoctor() {
      if (this.select_doc) {
        this.payload.doctor = {
          biz_id: this.select_doc.biz_id,
          doctor_license: this.select_doc.doctor_license,
          doctor_name: this.select_doc.name_th,
          one_id: this.select_doc.one_id
        }
      }
    },
    calculateAge(date) {
      if (date) {
        const y = Math.floor(moment.duration(moment().diff(date)).asYears());
        return y.toString();
      }
    },
    validateNumber: (event) => {
      const keyCode = event.keyCode;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    addItem() {
      this.drugItems.push({
        selectDrug: null,
        name: "",
        unit: "",
        quantity: "",
        usage: "",
        note: "",
      });
    },
    removeItem(index) {
      if (this.drugItems.length > 1) {
        this.drugItems.splice(index, 1);
      }
    },
    onDrugChange(item, index) {
      if (item) {
        this.drugItems[index].name = item.name_drug;
        this.drugItems[index].unit = item.unit;
        this.drugItems[index].usage = item.usage;
      }
    },
  }
}
</script>

<style scoped>
.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}

.card-medium-cancel {
  /* background: #ceefed; */
  border-radius: 20px 5px;
  box-shadow: none !important;
}

::v-deep .v-text-field>.v-input__control>.v-input__slot>.v-select__slot>input {
  line-height: 1.7rem;
}

::v-deep .v-text-field>.v-input__control>.v-input__slot>.v-text-field__slot>input {
  line-height: 1.7rem;
}
</style>
